import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'En solo 2 noches, mi bebé empezó a calmarse y yo volví a dormir. ¡Gracias por esta guía!',
  name: 'Laura M.'
}, {
  quote: 'Había intentado de todo. El Método de Micropausas fue el único que respetó mi cansancio.',
  name: 'Ana G.'
}, {
  quote: 'Mi pareja y yo ya no discutimos a medianoche. Funciona en equipo.',
  name: 'Carolina F.'
}];
export function ProofSection() {
  return <section className="py-20 bg-accent/10" data-id="element-278">
      <div className="max-w-5xl mx-auto px-6" data-id="element-279">
        <FadeIn data-id="element-280">
          <div className="text-center mb-12" data-id="element-281">
            <div className="flex justify-center gap-2 mb-6" data-id="element-282">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-accent fill-accent" data-id="element-283" />)}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brown-dark" data-id="element-284">
              Lo que dicen las mamás que ya lo probaron
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-285">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.15} direction="up" data-id="element-286">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-accent/20 h-full flex flex-col" data-id="element-287">
                <Quote className="w-8 h-8 text-accent/30 mb-4 flex-shrink-0" data-id="element-288" />
                <p className="text-lg text-brown-dark leading-relaxed font-serif italic flex-1" data-id="element-289">
                  "{t.quote}"
                </p>
                <p className="mt-6 font-bold text-brown-dark text-sm tracking-wide" data-id="element-290">
                  — {t.name}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}